import i18n from 'i18next';

/**
 * Format a date string as a localized relative time (e.g. "just now", "3m ago", "2d ago").
 * Falls back to a locale-aware date string after 7 days.
 */
export function formatTime(dateStr: string | null): string {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - d.getTime();
  const t = (key: string, opts?: Record<string, unknown>) =>
    i18n.t(key, { ns: 'common', ...opts });
  if (diff < 60000) return t('time.justNow');
  if (diff < 3600000) return t('time.minutesAgo', { count: Math.floor(diff / 60000) });
  if (diff < 86400000) return t('time.hoursAgo', { count: Math.floor(diff / 3600000) });
  if (diff < 604800000) return t('time.daysAgo', { count: Math.floor(diff / 86400000) });
  const locale = i18n.language === 'en' ? 'en-US' : 'zh-CN';
  return d.toLocaleDateString(locale);
}
